"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWhitelistedErrorFields;

var _invariant = _interopRequireDefault(require("invariant"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _values = _interopRequireDefault(require("lodash/values"));

var _without = _interopRequireDefault(require("lodash/without"));

var _apiConstants = require("@flowio/api-constants");

var _includes = _interopRequireDefault(require("lodash/includes"));

/**
 * @fileoverview
 *
 * This file contains configuration to determine what fields are safe to send to Rollbar. The data
 * sent to 3rd parties must be screened so that PII of customers is not passed along.
 *
 * With the exception of `generic_error` all error codes checked against in this file should come
 * from the generated constants defined in `@flowio/api-constants`. These values can be managed by
 * updating that dependency as the Flow API evolves.
 */
var isGenericError = function isGenericError(code) {
  return code === 'generic_error';
};

var orderErrorCodes = (0, _without.default)((0, _values.default)(_apiConstants.OrderErrorCode), 'generic_error');

var isOrderErrorCode = function isOrderErrorCode(code) {
  return (0, _includes.default)(orderErrorCodes, code);
};

var authorizationErrorCodes = (0, _values.default)(_apiConstants.AuthorizationDeclineCode);

var isAuthorizationErrorCode = function isAuthorizationErrorCode(code) {
  return (0, _includes.default)(authorizationErrorCodes, code);
};

var cardErrorCodes = (0, _values.default)(_apiConstants.CardErrorCode);

var isCardErrorCode = function isCardErrorCode(code) {
  return (0, _includes.default)(cardErrorCodes, code);
};

var creditPaymentErrorCodes = (0, _without.default)((0, _values.default)(_apiConstants.CreditPaymentErrorCode, 'generic_error'));

var isCreditPaymentErrorCode = function isCreditPaymentErrorCode(code) {
  return (0, _includes.default)(creditPaymentErrorCodes, code);
};
/**
 * Given an error code, return the fields that are allow to be sent to Rollbar as a list of paths.
 * The paths are intended to be used with the `get` function of lodash against the error object
 * itself.
 *
 * Codes that are not explicitly handled by this function will throw an error. The intent is for
 * the error to be caught and also be reported to Rollbar.
 */


function getWhitelistedErrorFields(code) {
  (0, _invariant.default)((0, _isString.default)(code), 'A code must be provided');

  if (isGenericError(code)) {
    return [];
  }

  if (isOrderErrorCode(code)) {
    return ['numbers', 'destination_country.iso_3166_3', 'threshold'];
  }

  if (isAuthorizationErrorCode(code) || isCardErrorCode(code)) {
    return ['avs', 'cvs'];
  }

  if (isCreditPaymentErrorCode(code)) {
    return ['codes'];
  }

  throw new Error("Unhandled error code[".concat(code, "]. Please update whitelisted fields to account for this new error. Check 'get-filtered-payload.js'"));
}